import React, { Component } from 'react';
import NavBar from './components/media-kit/NavBar';

class RoutingTest extends Component {

  render() {
    return (
      <div className="app container-fluid">
        <NavBar />
      </div>
    );
  }
}

export default RoutingTest;